import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=2d9c2a17&scoped=true"
import script from "./eventList.vue?vue&type=script&lang=js"
export * from "./eventList.vue?vue&type=script&lang=js"
import style0 from "./eventList.vue?vue&type=style&index=0&id=2d9c2a17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c2a17",
  null
  
)

export default component.exports